import React from 'react';
import CloseIcon from '../../assets/images/close-modal.svg'
import './Modal.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" >
      <div className="modal-content">
        {children}
        <button className="close-button" onClick={onClose} style={{marginTop: '2%'}} >
          <img src={CloseIcon} alt="" />
        </button>
      </div>
    </div>
  );
};

export default Modal;
